import Auth, { CognitoUser } from '@aws-amplify/auth';
import { call, put, takeEvery } from 'redux-saga/effects';
import { Actions as AuthActions, Types as AuthTypes } from 'services/authentication';
import { Actions as NotificationActions } from 'core/ui/notificationBar/actions';
import i18next from 'i18next';

function* disableMFA() {
  const user: CognitoUser = yield call([Auth, 'currentAuthenticatedUser']);

  try {
    yield call([Auth, 'setPreferredMFA'], user, 'NOMFA');
    yield put(AuthActions.updatePreferredMFA('NOMFA'));
  } catch (err) {
    yield put(NotificationActions.customNotification('secondary', i18next.t('common:errors.mfaDisableFailed')));
  }
}

export function* watchForDisableMFAAction() {
  yield takeEvery(AuthTypes.DISABLE_MFA, disableMFA);
}
